import { Component, OnInit, Input,
         Output, EventEmitter }    from '@angular/core';
import { FormGroup, FormControl, FormArray,
         FormBuilder, Validators } from '@angular/forms';

import { CsvService }              from './../../csv.service';
import { User }                    from './../../../../models/program/user';
import { Router }                  from '@angular/router';
import { ErrorService }            from '../../../../shared/services/error.service';
import { BatchResponse }           from '../../../../models/program/batch-response';
import { BatchCommitInfo }         from '../../../../models/program/batch-commit-info';

@Component({
  selector: 'app-batch-add-users-to-session',
  templateUrl: './batch-add-users-to-session.component.html',
  styleUrls: ['./batch-add-users-to-session.component.less']
})

export class BatchAddUsersToSessionComponent implements OnInit {
  @Input() batchResponse: BatchResponse;
  @Input() programId: number;
  @Input() sessionId: number;
  @Output() reset: EventEmitter<boolean> = new EventEmitter<boolean>();
  public existingUsers: User[];
  public batchForm: FormGroup;
  public usersToMove: number[] = [];
  public errors: string[];
  public saving: boolean;

  constructor(
    private router: Router,
    private errorService: ErrorService,
    private csvService: CsvService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.batchForm = this._fb.group({
      batch_ref: [this.batchResponse.batch_ref, <any>Validators.required],
      users_to_move: this._fb.array([])
    });

    if (this.batchResponse.existing_users) {
      this.existingUsers = this.batchResponse.existing_users;
      this.setUsers(this.existingUsers);
    }
  }

  /**
   * Public methods
   */

  public moveUser(id: number, bool: boolean): void {
    if (bool) {
      this.addUser(id);
    } else {
      this.removeUser(id);
    }
  }

  public resetData(bool: boolean): void {
    this.reset.emit(bool);
  }

  public commitBatch(): void {
    this.saving = true;
    this.csvService.commitBatchAddUsersToSession(
      this.programId,
      this.sessionId,
      {commit_info: this.batchForm.value as BatchCommitInfo}
    )
    .subscribe(res => {
      this.saving = false;
      this.reset.emit(true);
    }, error => {
      this.saving = false;
      this.errors = this.errorService.messages(error);
    });
  }

  /**
   * Private Methos
   */

  private setUsers(arr: User[]): void {
    arr.forEach(user => this.addUser(user.id));
  }

  private addUser(id?: number): void {
    this.usersToMove.push(id);
    const control = <FormArray>this.batchForm.controls['users_to_move'];
    control.push(new FormControl(id));
  }

  private removeUser(id: number): void {
    const control = <FormArray>this.batchForm.controls['users_to_move'];
    control.removeAt(this.usersToMove.indexOf(id));
    this.usersToMove.splice(this.usersToMove.indexOf(id), 1);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/batch/batch-add-users-to-session.component.ts